import { render } from "./PageSp.vue?vue&type=template&id=ee14a9b8&scoped=true"
import script from "./PageSp.vue?vue&type=script&lang=js"
export * from "./PageSp.vue?vue&type=script&lang=js"

import "./PageSp.vue?vue&type=style&index=0&id=ee14a9b8&scoped=true&lang=css"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee14a9b8"]])

export default __exports__